export default __webpack_public_path__ + "static/media/recurrence-calendar.479ed203.svg";